import React, { useEffect, useRef, useState } from "react";
import { Box, Typography } from "@mui/material";

const StatsCounter = ({ value, suffix = "", label, isVisible }) => {
  const [displayValue, setDisplayValue] = useState(0);
  const frameRef = useRef(null);

  useEffect(() => {
    if (!isVisible) {
      return undefined;
    }

    const duration = 1550;
    const start = performance.now();

    const tick = (time) => {
      const progress = Math.min((time - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplayValue(Math.round(value * eased));

      if (progress < 1) {
        frameRef.current = requestAnimationFrame(tick);
      }
    };

    frameRef.current = requestAnimationFrame(tick);

    return () => {
      if (frameRef.current) {
        cancelAnimationFrame(frameRef.current);
      }
    };
  }, [isVisible, value]);

  return (
    <Box
      sx={{
        flex: "0 0 auto",
        minWidth: { xs: 96, sm: 112 },
        pl: { xs: 1.5, md: 2 },
        pr: { xs: 1.5, md: 2.75 },
        borderInlineStart: "1px solid rgba(0,213,200,0.22)",
      }}
    >
      <Typography
        sx={{
          color: "#FFFFFF",
          fontSize: { xs: "1.55rem", md: "1.95rem" },
          fontWeight: 850,
          lineHeight: 1,
          letterSpacing: 0,
        }}
      >
        {displayValue.toLocaleString()}
        {suffix}
      </Typography>
      <Typography
        sx={{
          mt: 0.75,
          color: "rgba(0,213,200,0.85)",
          fontSize: { xs: "0.72rem", md: "0.8rem" },
          fontWeight: 600,
          lineHeight: 1.3,
          letterSpacing: "0.01em",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default StatsCounter;
